import React from "react";

import { roundNumber } from "../../../../../../utils/NumberHelpers";
import Checkbox from "../../../../../shared/forms/Checkbox";
import FormRow from "../../../../../shared/forms/FormRow";
import Margin from "../../../../../shared/Margin";
import useCalulatorStore from "../../../CalculatorPage/store";
import useCheckoutStore from "../../store";
import useStepDeliveryDetailsStore from "../store";

const ClimateNeutral = () => {
    const [additions, amount] = useCalulatorStore((state) => [
        state.additions,
        state.amount,
    ]);

    const [detailsHasChanged] = useCheckoutStore((state) => [
        state.detailsHasChanged,
    ]);

    const [climateNeutral, setClimateNeutral] = useStepDeliveryDetailsStore(
        (state) => [state.climateNeutral, state.setClimateNeutral]
    );

    /**
     * Calculates the climate neutral add.
     */
    const getClimateNeutralAdd = () => {
        return additions.climate_neutral_add
            ? roundNumber(
                  (parseFloat(additions.climate_neutral_add.replace(",", ".")) *
                      amount) /
                      100
              )
            : "";
    };

    /**
     * When the climate neutral changes.
     */
    const onChangeClimateNeutral = () => {
        setClimateNeutral(!climateNeutral);
        detailsHasChanged();
    };

    if (additions && additions.climate_neutral_add) {
        return (
            <FormRow
                bigLabel
                label={
                    <>
                        Klimaneutral
                        <Margin Component="span" left="10">
                            + {getClimateNeutralAdd()} €
                        </Margin>
                    </>
                }
                field={
                    <Checkbox
                        checked={climateNeutral === true}
                        onClick={onChangeClimateNeutral}
                    />
                }
            />
        );
    }

    return null;
};

export default ClimateNeutral;
